module.exports = __webpack_public_path__ + "img/dog1.e213a0cd.jpg";